import React, { memo, PropsWithChildren } from 'react';
import { Collapsible, CollapsibleContent } from 'components/ui/collapsible';
import { Switch } from 'components/ui/switch';
import { cn } from 'lib/utils';

interface Props extends PropsWithChildren {
  onChange: (expanded: boolean) => void;
  expanded: boolean;
  title: string;
  description?: string;
}

function ExpandablePaper(props: Props) {
  const { title, expanded, onChange, description, children } = props;

  return (
    <Collapsible open={expanded} onOpenChange={onChange}>
      <div className="flex items-center justify-between gap-4 p-4 bg-muted rounded-t-lg border-b border-border">
        <div className="flex flex-col flex-grow min-w-0">
          <p
            className="font-medium text-lg sm:text-2xl leading-8 text-foreground truncate m-0"
            title={title}
          >
            {title.length > 35 ? title.slice(0, 36) + '...' : title}
          </p>
          {description && (
            <span className="text-sm text-muted-foreground mt-1">
              {description}
            </span>
          )}
        </div>
        <Switch checked={expanded} onCheckedChange={onChange} />
      </div>
      <CollapsibleContent className="transition-all data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
        <div className="pt-4 px-4 pb-4 box-border bg-background rounded-b-lg">
          {children}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}

export default memo(ExpandablePaper);
